<template>
  <div class="page">
    <div class="page-main">
      <div class="page-header">
        <h1 class="page-title">{{ $t("support.labels.contactUS") }}</h1>
      </div>
      <div class="page-content">
        <div class="panel">
          <div class="panel-body panel-form">
            <loading-indicator v-if="isLoading"></loading-indicator>
            <form v-else v-on:submit.prevent="onSubmit" autocomplete="off">
              <div class="row">
                <div class="col-md-6 col-xs-12">
                  <p>{{ $t("support.labels.textGuide") }}</p>
                  <alert v-show="showAlert"
                    alertClass="m-b-25 alert-dismissible"
                    v-bind:type="`${ (successResponse) ? 'success' : 'danger' }`"
                    v-bind:iconClass="`${ (successResponse) ? 'md-check' : 'md-close' }`">
                    <span v-if="successResponse">{{successResponse}}</span>
                    <span v-else-if="errorResponse">{{errorResponse}}</span>
                  </alert>
                  <div class="form-section">
                    <form-group v-bind:error="formErrors.first('subject')">
                      <label for="subject">{{ $t("support.labels.subject") }} <span class="red-600">*</span></label>
                      <input type="text" class="form-control input-lg" v-model="support.subject" autocomplete="false">
                    </form-group>
                    <form-group v-bind:error="formErrors.first('content')">
                      <label for="content">{{ $t("support.labels.message") }} <span class="red-600">*</span></label>
                      <textarea type="text" class="form-control input-lg" v-model="support.content" autocomplete="false" rows="12"></textarea>
                    </form-group>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <button type="submit" class="btn btn-success" :disabled="isSubmiting" v-bind:class="{ 'btn-default': isSubmiting }">
                    <div class="loader vertical-align-middle loader-circle loader-form" v-if="isSubmiting"></div> {{ $t("action.submit") }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import { mapGetters } from 'vuex';
import FormGroup from 'components/forms/FormGroup';
import Alert from 'components/Alert';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    FormGroup,
    Alert,
    LoadingIndicator,
  },
  watch: {
    'support.subject': function() {
      if (this.formErrors.has('subject')) {
        this.formErrors.remove('subject');
      }
    },
    'support.content': function() {
      if (this.formErrors.has('content')) {
        this.formErrors.remove('content');
      }
    },
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
  },
  data: function () {
    return {
      isSubmiting: false,
      isLoading: false,
      showAlert: false,
      validator: null,
      formErrors: null,
      errorResponse: null,
      successResponse: null,
      support: [],
    };
  },
  created: function() {
    this.validator = new Validator();
    this.validator.attach('subject', 'required', { prettyName: 'Subject' });
    this.validator.attach('content', 'required', { prettyName: 'Content' });

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  methods: {
    onSubmit: function () {
      this.showAlert = false;
      this.validator.validateAll({
        subject: this.support.subject,
        content: this.support.content,
      })
      .then((success) => {
        if (!success) {
          return;
        }

        this.isSubmiting = true;
        axios.post(`/api/support/messages`, {
          subject: this.support.subject,
          content: this.support.content,
        })
        .then(() => {
          this.isSubmiting = false;
          this.support = [];
          this.successResponse = this.$t('contact.response.success');
          this.errorResponse = null;
          this.showAlert = true;
        })
        .catch((error) => {
          this.isSubmiting = false;

          if (error.response.status === 422) {
            this.errorResponse = this.$t('team.response.failed');
            this.formErrors.addAll(error.response.data);
          } else if (error.response.status === 400) {
            this.errorResponse = this.$t('changePassword.response.failed');
          } else {
            this.errorResponse = this.$t('team.response.defaultFailed');
          }

          this.showAlert = true;
        });
      })
      .catch(() => {

      });
    },
  },
};
</script>

<style>
textarea
{
resize:none;
}

</style>



// WEBPACK FOOTER //
// Support.vue?2c108c73